<template>
    <div class="pop-view-award" :class="`pop-view-award-${store.popData.level_num}`">
        <div class="pop-bg"></div>
        <div class="pop-content">
            <div class="award-img">
                <img class="award-img-item" :src="store.popData.reward_img_url" alt="" />
                <div class="award-img-bg pop-award-bg2"></div>
                <img class="award-img-avatar" :src="store.indexData.user_info.avatar" alt="" />
            </div>
            <p class="award-title">{{ store.popData.reward_title }}</p>
            <p class="award-tip">{{ store.popData.reward_desc }}</p>
            <p class="award-tip2" v-if="store.popData.reward_second_desc">{{ store.popData.reward_second_desc }}</p>
            <p class="award-tip2 award-tip3" v-if="store.popData.reward_third_desc">{{ store.popData.reward_third_desc }}</p>
            <div class="award-btn button-1 g-flex-center-center" @click="onClick">
                <p class="award-btn-text">{{ store.popData.reward_btn_title }}</p>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { getCurrentInstance, ref } from 'vue';
import { useStore } from '@/store';
import { jsbSupportMap, schemaSupportMap, schemaSingle } from '@q-front-npm/jsbridge';
const instance = getCurrentInstance();
const store = useStore();
const onClick = () => {
    const url = store.popData.reward_btn_url;
    if (!url) {
        store.setPopStatus('viewAward', false);
        return;
    }
    // 是否是勋章， 低版本提示升级
    if (url.indexOf('medal_center') > -1) {
        if (schemaSupportMap.medal_center) {
            schemaSingle.openSchema(url);
        } else {
            instance!.proxy.$toast('请升级至最新版本');
        }
        return;
    }
    schemaSingle.openSchema(url);
};
</script>
<style lang="scss" scoped>
.pop-view-award {
    position: relative;
    width: 600px;
    margin: 0 auto;
    .pop-content {
        position: absolute;
        top: 110px;
        left: 0;
        right: 0;
        bottom: 0;
    }

    &-3 {
        .pop-content {
            top: 80px;
        }
    }
    // 头像
    &-2,
    &-6 {
        .award-img-avatar {
            display: block;
        }
    }
}

.award {
    &-img {
        width: 240px;
        height: 240px;
        margin: 0 auto;
        position: relative;
        &-item {
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 2;
        }
        &-bg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        &-avatar {
            width: 194px;
            height: 194px;
            position: absolute;
            border-radius: 50%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            display: none;
        }
    }
    &-title {
        text-align: center;
        margin-top: 20px;
        font-weight: bold;
        font-size: 30px;
        color: #276ad1;
        line-height: 42px;
    }
    &-tip {
        text-align: center;
        margin-top: 8px;
        font-size: 24px;
        color: #5174b4;
        line-height: 34px;
    }
    &-tip2 {
        margin-top: 12px;
        text-align: center;
        font-size: 20px;
        color: rgba(81, 116, 180, 0.6);
        line-height: 28px;
    }
    &-tip3 {
        margin-top: 0;
    }
    &-btn {
        margin: 40px auto 0;

        &-text {
            font-weight: bold;
            font-size: 28px;
            color: #a9582f;
            line-height: 1.2;
        }
    }
}
</style>
